import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var RequestBaseData =
/*#__PURE__*/
function (_BaseData) {
  _inherits(RequestBaseData, _BaseData);

  function RequestBaseData(c) {
    _classCallCheck(this, RequestBaseData);

    return _possibleConstructorReturn(this, _getPrototypeOf(RequestBaseData).call(this, c));
  }

  _createClass(RequestBaseData, [{
    key: "UnSubmit",
    value: function () {
      var _UnSubmit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.post("/api/".concat(this._controller, "/UnSubmit/").concat(id)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function UnSubmit(_x) {
        return _UnSubmit.apply(this, arguments);
      }

      return UnSubmit;
    }()
  }, {
    key: "Review",
    value: function () {
      var _Review = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(obj) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.post("/api/".concat(this._controller, "/Review}"), obj));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function Review(_x2) {
        return _Review.apply(this, arguments);
      }

      return Review;
    }()
  }, {
    key: "ChangeStatus",
    value: function () {
      var _ChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(obj) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.post("/api/".concat(this._controller, "/ChangeStatus}"), obj));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function ChangeStatus(_x3) {
        return _ChangeStatus.apply(this, arguments);
      }

      return ChangeStatus;
    }()
  }, {
    key: "GetByStatus",
    value: function () {
      var _GetByStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(statusId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByStatus/").concat(statusId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function GetByStatus(_x4) {
        return _GetByStatus.apply(this, arguments);
      }

      return GetByStatus;
    }()
  }, {
    key: "GetByStatusAndProperty",
    value: function () {
      var _GetByStatusAndProperty = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(statusId, propertyId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByStatus/").concat(propertyId, "/").concat(statusId)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function GetByStatusAndProperty(_x5, _x6) {
        return _GetByStatusAndProperty.apply(this, arguments);
      }

      return GetByStatusAndProperty;
    }()
  }]);

  return RequestBaseData;
}(BaseData);

export default RequestBaseData;